import React, { memo } from 'react';
import Modal from 'ds/components/modal';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { LogoLoader } from './LogoLoader';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { TranzilaModalType } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin: 0 auto;
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 370px;
    height: 370px;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  `}
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  max-width: 310px;
`;

const Message = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  max-width: 310px;
`;

const InfoBlock = styled.div(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

interface ProcessingModalProps {
  stateType: TranzilaModalType;
}

export const ProcessingModal: React.FC<ProcessingModalProps> = memo(({ stateType }) => {
  const { t } = useLocale();
  const screen = useScreenBreakpoint();
  const isDesktop = screen >= 3;

  let infoSlot: React.ReactNode = null;
  switch (stateType) {
    case TranzilaModalType.Loading:
    case TranzilaModalType.Initiation: {
      infoSlot = (
        <InfoBlock>
          <Title>{t('tranzila.hostedFields.initiation.title')}</Title>
        </InfoBlock>
      );
      break;
    }
    case TranzilaModalType.Processing:
    case TranzilaModalType.Paying: {
      infoSlot = (
        <InfoBlock>
          <Title>{t('tranzila.hostedFields.processing.title')}</Title>
          <Message>{t('tranzila.hostedFields.processing.text')}</Message>
        </InfoBlock>
      );
      break;
    }
    default: {
      infoSlot = null;
      break;
    }
  }

  return (
    <Modal
      isOpen
      onClose={null}
      isFullWidthMainContent
      desktopModalPositionCenter
      hideCloseButton
      contentWrapperStyle={{
        borderRadius: isDesktop ? 24 : '16px 16px 0 0',
      }}
    >
      <Wrapper>
        <LogoLoader />
        {infoSlot}
      </Wrapper>
    </Modal>
  );
});
